import axios from "axios";
import { CartActions } from "../Slices/CartSlice";
import { SERVICE_URL } from "../ServiceUrls";
import { store } from "../Store";

const currentUser = store.getState().user.currentUser;

// Helper function to push cart events to dataLayer
function pushCartEvent(data, eventType = 'cart_updated') {
    const cart = data?.data;
    const cartItems = cart?.cartItems;
    if (cartItems?.length > 0) {
        const gtagItems = cartItems?.map((item, index) => ({
            item_id: item?.book?.sku || item?.bestSellerBook?.sku, // ISBN as item_id
            item_name: item?.book?.title || item?.bestSellerBook?.title, // Book title
            affiliation: "Rare Biblio",
            coupon: cart?.couponCode || "",
            total_discount: cart?.discount || 0,
            index,
            item_brand: "Rare Biblio",
            item_category: "Books",
            item_category2: item.genres || "Fiction",
            item_category3: item.language || "English",
            item_list_id: "cart",
            item_variant: item.variantType === "deluxe" ? "Deluxe" : "Super Deluxe",
            price: item?.itemPrice,
            quantity: item.quantity,
        }));

         // Get user email (you'll need to determine how to get this)
        const userEmail = currentUser?.userId; // Implement this function
        
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: eventType,
            cartData: {
                data: {
                    [userEmail]: {
                        items: gtagItems,
                        totalItems: cartItems?.length
                    }
                }
            },
            timestamp: new Date().toISOString()
        });
    }
}

// Function to fetch all cart items
function getCartItems() {
    return axios({
        url: `${SERVICE_URL.CART}`,
        method: 'get',
        responseType: 'json'
    });
}

export function fetchAllCartItems(dispatch, pushUpdate = false) {
    return getCartItems().then(function (response) {
        let data = response.data;
        if (data.success) {
            dispatch(CartActions.updateCartItems(data.data?.cartItems));
            dispatch(CartActions.fetchCart(data.data));
            if(pushUpdate) {
                pushCartEvent(data)
            }
            return data;
        }
    }).catch(function (error) {
        console.log(error);
    });
}

// Function to add a new cart item
export function addCartItem(bookData, quantity,variant,leatherType,color,dispatch,bookCustomization,isDesignSaved=false) {
    let formData = new FormData();
    formData.append("bookData", JSON.stringify(bookData));
    formData.append("quantity", quantity);
    formData.append("variantType", variant);
    formData.append("leatherType", leatherType);
    formData.append("color", color);
    formData.append("isDesignSaved",isDesignSaved);
    
    if(bookCustomization){
        formData.append("bookCustomization",JSON.stringify(bookCustomization))
    }
    
    return axios({
        url: `${SERVICE_URL.CART}/item`,
        headers: { "content-type": "multipart/form-data" },
        method: "post",
        data: formData,
        responseType: "json",
    }).then(function (response) {
        let data = response.data;
        if (data.success) {
            dispatch(CartActions.addCartItemSuccess(data.data.cartItems));
            fetchAllCartItems(dispatch,true);
        }
        return data;
    });
}
export function addBestSellerCartItem(bookData, quantity,variant,leather,color,dispatch) {
    let formData = new FormData();
    formData.append("bookData", JSON.stringify(bookData));
    formData.append("quantity", quantity);
    formData.append("variantType", variant);
    formData.append("leatherType", leather);
    formData.append("color", color);
    
    return axios({
        url: `${SERVICE_URL.CART}/add-best-seller`,
        headers: { "content-type": "multipart/form-data" },
        method: "post",
        data: formData,
        responseType: "json",
    }).then(function (response) {
        let data = response.data;
        if (data.success) {
            dispatch(CartActions.addCartItemSuccess(data.data.cartItems));
            fetchAllCartItems(dispatch,true);
        }
        return data;
    });
}

export function addExclusiveCartItem(bookData, quantity,color,dispatch) {
    let formData = new FormData();
    formData.append("bookData", JSON.stringify(bookData));
    formData.append("quantity", quantity);
    formData.append("color", color);
    
    return axios({
        url: `${SERVICE_URL.CART}/add-exclusive-book`,
        headers: { "content-type": "multipart/form-data" },
        method: "post",
        data: formData,
        responseType: "json",
    }).then(function (response) {
        let data = response.data;
        if (data.success) {
            dispatch(CartActions.addCartItemSuccess(data.data.cartItems));
            fetchAllCartItems(dispatch,true);
        }
        return data;
    });
}

// Function to update a cart item
export function updateCartItem(itemId, quantity,addressId, dispatch,wantBoxWrapping = false,wantGiftWrapping = false,shippingSpeed) {
    let formData = new FormData();
    formData.append("quantity", quantity);
    if(addressId){
        formData.append("addressId", addressId ? addressId : null);
    }
    formData.append("boxWrapping", wantBoxWrapping);
    formData.append("giftWrapping", wantGiftWrapping);
    if(shippingSpeed){
        formData.append("shippingSpeed",shippingSpeed)
    }
    
    return axios({
        url: `${SERVICE_URL.CART}/item/${itemId}`,
        headers: { "content-type": "multipart/form-data" },
        method: "put",
        data: formData,
        responseType: "json",
    }).then(function (response) {
        let data = response.data;
        if (data.success) {
            fetchAllCartItems(dispatch,true);
        }
        return data;
    });
}


export function updateAllCartItemsAddress(addressId, dispatch) {
    
    return axios({
        url: `${SERVICE_URL.CART}/update-all-address?addressId=${encodeURIComponent(addressId)}`,
        headers: { "content-type": "multipart/form-data" },
        method: "post",
        responseType: "json",
    }).then(function (response) {
        let data = response.data;
        if (data.success) {
            fetchAllCartItems(dispatch);
        }
        return data;
    });
}

// Function to delete a cart item
export function deleteCartItem(itemId, dispatch) {
    return axios({
        url: `${SERVICE_URL.CART}/item/${itemId}`,
        method: 'delete',
        responseType: 'json'
    }).then(function (response) {
        let data = response.data;
        if (data.success) {
            // dispatch(CartActions.removeCartItem(itemId));
            fetchAllCartItems(dispatch,true);
        }
        return data;
    });
}

// Function to get cart item details
export function getCartItemDetails(itemId, dispatch) {
    return axios({
        url: `${SERVICE_URL.CART}/item/${itemId}`,
        method: 'get',
        responseType: 'json'
    }).then(function (response) {
        let data = response.data;
        if (data.success) {
            dispatch(CartActions.addCartItemSuccess(data.data));
        }
        return data;
    });
}

export function applyCoupon(couponCode) {
    return axios({
        url:`${SERVICE_URL.CART}/apply-coupon?couponCode=${couponCode}`,
        method:"get",
    }).then((res) => {
        return res;
    }).catch((err) => {
        console.error(err)
    })
}

export function applyWallet() {
    return axios({
        url:`${SERVICE_URL.CART}/use-wallet-amount`,
        method:"get",
    }).then((res) => {
        return res;
    }).catch((err) => {
        console.error(err)
    })
}


export function removeCoupon() {
    return axios({
        url:`${SERVICE_URL.CART}/remove-coupon`,
        method:"get",
    }).then((res) => {
        return res;
    }).catch((err) => {
        console.error(err)
    })
}

export function removeWallet() {
    return axios({
        url:`${SERVICE_URL.CART}/remove-wallet-amount`,
        method:"get",
    }).then((res) => {
        return res;
    }).catch((err) => {
        console.error(err)
    })
}